var map = {
	"./slogan1.png": "ARWl",
	"./slogan1_black.png": "FejH",
	"./slogan2.png": "eV28",
	"./slogan2_black.png": "5FAS",
	"./slogan3.png": "GTQ3",
	"./slogan3_black.png": "m7jc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "taZb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slogan ^\.\/slogan.*\.png$
// module id = taZb
// module chunks = 0